export enum IconType {
  CART,
  BIN,
  EDIT,
}
